var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2727_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.383 24 0 18.617 0 12C0 5.383 5.383 0 12 0C18.617 0 24 5.383 24 12C24 18.617 18.617 24 12 24Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.959 13.524L15.69 12.961C15.153 12.828 14.592 13.025 14.259 13.466L13.45 14.537C11.762 13.587 10.355 12.172 9.42902 10.494L10.474 9.716C10.918 9.385 11.119 8.824 10.983 8.289L10.416 6.036C10.262 5.426 9.71402 5 9.08002 5L6.36302 5.02C5.98002 5.022 5.62702 5.178 5.36902 5.458C5.10902 5.74 4.97502 6.124 5.00402 6.51C5.48302 13.113 10.853 18.481 17.495 18.995C17.532 18.999 17.569 19 17.605 19C17.96 19 18.305 18.867 18.564 18.627C18.844 18.367 18.999 18.014 18.999 17.632V14.851C19 14.222 18.572 13.676 17.959 13.524Z",
    fill: "#ECEFF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2727_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.d375aa19bf35566798926709a3221754.svg";
export { ForwardRef as ReactComponent };